import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LogElectronService } from '../logElectron/log-electron.service';
import { LOG_EVENT ,LOG_LEVEL } from '../../model/eLogElectron';
import { Mask, MaskService } from '../mask/mask.service';
import { ConfigurationControlService } from '../configuration/configurationControl.service';
import { LtiService } from '../LTI/lti.service';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private logElectronService: LogElectronService,
    private _maskService: MaskService,
    private _configurationControlService: ConfigurationControlService,
    private _ltiService: LtiService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let uuidSesion: string = sessionStorage.getItem('uuidSesion');
    let request = req;

    const skipIntercept = request.headers.has('skip');

    if (skipIntercept) {
      request = request.clone({
        headers: request.headers.delete('skip')
      });
      return next.handle(request);
    }

    if (uuidSesion != '' && uuidSesion != undefined && uuidSesion != null && uuidSesion != 'null' && uuidSesion != 'NULL') {
      request = req.clone({
        setHeaders: {
          uuid: uuidSesion
        }
      });
    }



    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        try {
          this.logElectronService.saveLog(LOG_LEVEL.ERROR, LOG_EVENT.E_PETICION, 
            `url=${request.url} status=${err.status} message='${err.message}'`)
        } catch (e) {} 
        if (err.status === 401) {
          this._maskService.setMask(Mask.multisesionErrorMask, true);
          sessionStorage.setItem('uuidSesion', '');
          if(this._configurationControlService.examConfiguration.securitySumadi) {
            this._ltiService.sumadiData = undefined;
            this._ltiService.idSessionStart = undefined;        
          }
        }
        return throwError(err);
      })
    );
  }

}